const constants = {
  PROCESS_PICKUP: {
    MESSAGES: {
      SUCCESS: "Pickup completed successfully.",
      FAILED: "Failed to complete pickup.",
    },
    LOADER: "Processing Pickup",
    TITLE: "Process a Pickup",
  },
  ADD_PRO_TO_PICKUP: {
    MESSAGES: {
      SUCCESS: "Pickup updated successfully.",
      FAILED: "Failed to update pickup.",
    },
    LOADER: "Updating Pickup",
    TITLE: "Add Pro to Pickup",
  },
  VALIDATION: {
    CUSTOMER_NAME: "* Customer Name is required",
    NO_FREIGHT_REASON_CODE: "* Reason Code is required",
  },
  SESSION_ADDED_SHIPMENT_PREFIXES: ["NewShipment", "NewPickupShipment"],
  MIN_CONSIGNEE_ZIP: 5
};

export default constants;
